<template>
  <BgImageLayout title="Metadata categories">
    <AgGridWrapper
      ref="categoriesWrapper"
      :actions="categoriesWrapperActions"
      :options="gridOptions"
      :separator="true"
      :include-search-box="true"
      store-namespace="metaDataCategories"
      service-namespace="meta-data-categories"
      @show-form="showForm = true"
    />

    <FormCreateMetaDataCategory :showing="showForm" @close="showForm = false" @create="refresh($event)" />

    <LmDialog v-if="deletable" :uid="uid" :entity="deletable" store-namespace="metaDataCategories" />
  </BgImageLayout>
</template>
<script>
import { dateRenderer, dateSorter } from '@/lib/generic.utils'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import { uid } from 'quasar'
import { mapState } from 'vuex'
// Components
import { FormCreateMetaDataCategory } from '@components/forms'
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import LmDialog from '@components/lm-blocks/Dialog'

export default {
  name: 'LmPageMetaDataCategoryIndex',
  components: {
    FormCreateMetaDataCategory,
    AgGridWrapper,
    LmDialog
  },

  data() {
    return {
      showForm: false,
      deletable: null,
      uid: uid()
    }
  },

  computed: {
    ...mapState({
      categories: state => state.metaDataCategories.all
    }),

    categoriesWrapperActions() {
      return [
        {
          label: 'Create new category',
          event: 'show-form',
          type: 'button',
          color: 'tertiary',
          size: 'md'
        }
      ]
    },

    gridOptions() {
      return {
        rowData: this.categories,
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: true,
            cellRenderer: params => params.value
          },
          {
            headerName: 'Created',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Updated',
            field: 'updated_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Actions',
            cellRendererFramework: LmEntityActions
          }
        ]
      }
    }
  },

  methods: {
    refresh(event) {
      this.$refs.categoriesWrapper.gridOptions.api.applyTransaction({ add: [event] })
    },

    delete(params) {
      this.$set(this, 'deletable', params.data)
      this.$store.dispatch('metaDataCategories/deleteConfirmation', {
        id: this.deletable.id,
        dialogUid: this.uid
      })
    }
  }
}
</script>
